import type { ChannelFilters } from "stream-chat";

export const buildDashboardGuestChatsFilters = (
  streamUserId: string,
): ChannelFilters =>
  ({
    members: { $in: [streamUserId] },
    type: "messaging",
    last_message_at: { $exists: true },
    $or: [{ resolved: { $exists: false } }, { resolved: false }],
  }) as ChannelFilters;
